import React, { useEffect, useState, useCallback } from "react";
import "./ZoomControl.css";

const inchesPerMeter = 39.37;
const initialResolution = 156543.03392804097;

const getRealDPI = () => 96 * (window.devicePixelRatio || 1);

const zoomToScale = (zoom) => {
  const dpi = getRealDPI();
  const resolution = initialResolution / Math.pow(2, zoom);
  const scaleDenominator = resolution * dpi * inchesPerMeter;

  return `1:${Math.round(scaleDenominator).toLocaleString("en-US")}`;
};

const ZoomControl = ({ zoom, mapRef, viewState, setViewState }) => {
  const [scale, setScale] = useState("");

  const currentZoom = viewState?.zoom ?? zoom ?? 1;

  const updateScale = useCallback(() => {
    if (mapRef?.current?.getZoom) {
      setScale(zoomToScale(mapRef.current.getZoom()));
      return;
    }

    setScale(zoomToScale(currentZoom));
  }, [mapRef, currentZoom]);

  useEffect(() => {
    updateScale();

    const interval = setInterval(updateScale, 500);
    return () => clearInterval(interval);
  }, [updateScale]);

  const handleZoomChange = (delta) => {
    if (typeof setViewState === "function") {
      setViewState((prev) => ({
        ...prev,
        zoom: Math.max(1, (prev.zoom ?? currentZoom) + delta),
      }));

      return;
    }

    if (mapRef?.current?.getZoom && mapRef.current?.setZoom) {
      const nextZoom = Math.max(1, mapRef.current.getZoom() + delta);
      mapRef.current.setZoom(nextZoom);
    }
  };

  return (
    <div className="zoom-control">
      <button type="button" onClick={() => handleZoomChange(1)}>
        +
      </button>

      <div className="zoom-control-scale">{scale}</div>

      <button type="button" onClick={() => handleZoomChange(-1)}>
        −
      </button>
    </div>
  );
};

export default ZoomControl;